import { types } from "../types/types";

const initialState = {
  cargada: false,
  itemsUsuario: [],
  items: [],
  loading: false,
  error: null,
};

export const preAfiliacionesTomadasReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.preAfiliacionesTomadasTraerStart:
      return {
        ...state,
        loading: true,
        error: null,
        cargada: false,
      };
    case types.preAfiliacionesTomadasTraerSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        cargada: true,
      };
    case types.preAfiliacionesTomadasUsuarioTraerSuccess:
      return {
        ...state,
        loading: false,
        itemsUsuario: action.payload,
        cargada: true,
      };
    case types.preAfiliacionesTomadasTraerError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        items: [],
        itemsUsuario: [],
        cargada: false,
      };
    case types.preAfiliacionesTomadasUsuarioAgregar:
      return {
        ...state,
        loading: false,
        itemsUsuario: [ ...state.items, action.payload ],
        cargada: true,
      };
    case types.preAfiliacionesTomadasUsuarioLiberar:
      return {
        ...state,
        loading: false,
        itemsUsuario: state.items.filter( item => item.id !== action.payload ),
        cargada: true,
      };
    case types.preAfiliacionesTomadasLiberar:
      return {
        ...state,
        loading: false,
        items: state.items.filter( item => item.id !== action.payload ),
        cargada: true,
      };
    case types.preAfiliacionesTomadasLimpiar:
      return {
        loading: false,
        items: [],
        itemsUsuario: [],
        cargada: false,
      };
    default:
      return state;
  }
};
